<div class="notif-panel" (click)="$event.stopPropagation()">
  @if (!mostrarConfig) {
    <!-- Header -->
    <div class="tabla-menu-header">
      <span class="tabla-menu-titulo">
        <mat-icon>notifications</mat-icon>
        Notificaciones
        @if (totalCount && !verLeidas) {
          <span class="notif-count">
            {{ totalCount.toLocaleString('es-AR') }}
          </span>
        }
      </span>
      <div class="notif-header-acciones">
        <button irxBoton="texto" tamano="compacto" (click)="toggleVerTodas()">
          {{ !verLeidas ? 'Ver leídas' : 'Ver no leídas' }}
        </button>
        @if (totalCount) {
          <!-- «Marcar como leída» no tiene ícono en docs/ICONOS.md: va con texto -->
          <button
            irxBoton="texto"
            tamano="compacto"
            (click)="marcarTodasComoLeidas()"
          >
            Marcar todas leídas
          </button>
        }
      </div>
    </div>

    <!-- Lista (scrollable) -->
    <div class="notif-scroll">
      @if (totalCount) {
        @for (n of notificaciones; track n._id; let even = $even) {
          <div
            class="notif-item"
            [ngClass]="{
              'notif-leida-par': verLeidas && even,
              'notif-leida-impar': verLeidas && !even,
              'notif-no-leidas': !verLeidas,
            }"
          >
            <div class="notif-item-content">
              <h3 class="notif-titulo">{{ n.titulo }}</h3>
              <p class="notif-mensaje">{{ n.mensaje }}</p>
              <span class="notif-fecha">
                {{ fecha(n.fechaCreacion) }} · {{ hace(n.fechaCreacion) }}
              </span>
            </div>
            <div class="notif-item-acciones">
              @if (!verLeidas) {
                <button
                  irxBoton="texto"
                  tamano="compacto"
                  (click)="marcarComoLeida(n)"
                >
                  Marcar leída
                </button>
              } @else {
                <button
                  irxBoton="texto"
                  tamano="compacto"
                  (click)="marcarComoNoLeida(n)"
                >
                  Marcar no leída
                </button>
                <button
                  irxBotonIcono
                  tono="peligro"
                  tooltip="Eliminar"
                  (click)="eliminar(n)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      } @else {
        <div class="notif-empty">
          <mat-icon>notifications_off</mat-icon>
          <span>
            {{ verLeidas ? 'Sin notificaciones leídas' : 'Sin notificaciones' }}
          </span>
        </div>
      }
    </div>

    <!-- Ver todas las leídas (abre dialog con paginador + búsqueda) -->
    @if (verLeidas) {
      <div class="notif-footer">
        <button
          irxBoton="texto"
          bloque
          (click)="verTodasLeidas()"
        >
          <mat-icon>open_in_full</mat-icon>
          Ver todas las leídas
        </button>
      </div>
    }
  }

  @if (mostrarConfig) {
    <app-configurar-notificaciones></app-configurar-notificaciones>
  }
</div>
